module.exports = __webpack_public_path__ + "static/media/heart.24fcca9b.svg";